// Single source of truth for the current weekly briefing.
// Each Monday, update the fields below to point the homepage announcement bar
// and the homepage featured-insight card at the newest approved briefing.
// Set `active: false` to hide the announcement bar without removing it.

export const FEATURED_BRIEFING = {
  active: true,
  slug: "uae-africa-legal-regulatory-briefing-26-october-2026",
  title: "UAE–Africa Legal & Regulatory Briefing",
  dateRange: "19–25 October 2026",
  alertText: "UAE–Africa Legal & Regulatory Briefing: 19–25 October 2026",
  summary:
    "Tanzania's seven banking-regulation consultations close 28 October, South Africa issues telecommunications infrastructure policy, UAE VAT returns fall due under new employee-expense recovery conditions, and South Africa proposes public-finance reforms.",
  jurisdictions: ["UAE", "South Africa", "Tanzania", "Nigeria"],
};

export const briefingPath = (b = FEATURED_BRIEFING) => `/insights/${b.slug}`;
